import { apiService, ApiResponse } from './apiService';
import { TermsContent } from '../types/terms';

/**
 * Terms & conditions API — EUTC content, acceptance recording and the forced
 * password change that can accompany an admin-issued temporary password.
 */
export const termsApi = {
  /** GET /api/terms — public endpoint returning WTOU + EUTC content. */
  fetchTerms: (): Promise<ApiResponse<TermsContent>> =>
    apiService.get<TermsContent>('/terms'),

  /** POST /api/auth/accept-eutc — records the logged-in user's acceptance. */
  acceptEutc: (): Promise<ApiResponse> => apiService.post('/auth/accept-eutc'),

  /**
   * POST /api/auth/change-password — sets a new password for the logged-in
   * user. Backend enforces: >=8 chars, >=1 letter, >=1 number.
   */
  changePassword: (newPassword: string): Promise<ApiResponse> =>
    apiService.post('/auth/change-password', { newPassword }),
};
